<header class="innova-header">
  <div class="nav-left">
    <button class="menu-toggle-btn" matRipple (click)="toggleSideNav()">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6 21C5.20435 21 4.44129 20.6839 3.87868 20.1213C3.31607 19.5587 3 18.7956 3 18V6C3 5.20435 3.31607 4.44129 3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3H18C18.7956 3 19.5587 3.31607 20.1213 3.87868C20.6839 4.44129 21 5.20435 21 6V18C21 18.7956 20.6839 19.5587 20.1213 20.1213C19.5587 20.6839 18.7956 21 18 21H6ZM18 5H10V19H18C18.2652 19 18.5196 18.8946 18.7071 18.7071C18.8946 18.5196 19 18.2652 19 18V6C19 5.73478 18.8946 5.48043 18.7071 5.29289C18.5196 5.10536 18.2652 5 18 5Z"
          fill="black"
        />
      </svg>
    </button>

    <a routerLink="/home">
      <img class="nav-logo" aria-label="Innova Links" src="../assets/images/Linkerweb_Logo 02.png" alt="Innova Logo" />
    </a>

 
  </div>

  @if (menu.length) {
    <div class="menu-container">
      @for (item of menu; track $index) {
        <div class="nav-item-wrapper">
          <a
            class="nav-link"
            [routerLink]="item.url"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active"
          >
            {{ item.name }}
          </a>

          <div class="link-glow" *ngIf="isActive(item.url)"></div>
        </div>
      }
    </div>
  }

  <div class="other-actions">
    @if (hasPermission('shipment:access', 'shipment')) {
      <button (click)="op.toggle($event)" class="button-link">
        <mat-icon aria-hidden="false" [matBadge]="notificationsCount" [matBadgeHidden]="notificationsCount < 1">
          notifications
        </mat-icon>
      </button>

      <p-popover #op styleClass="notifications-menu">
        <div class="notifications">
          <div class="notifications__header">
            <div class="notifications__header-title">
              <mat-icon>notifications</mat-icon>
              <h3>Notificaciones</h3>
            </div>
            @if (notificationsCount > 0) {
              <span class="notifications__count">{{ notificationsCount }}</span>
            }
          </div>

          <div class="notifications__list">
            @if (notifications.length === 0) {
              <div class="notifications__empty">
                <mat-icon>notifications_none</mat-icon>
                <p class="notifications__empty-title">Sin notificaciones</p>
                <p class="notifications__empty-subtitle">Aquí verás tus avisos cuando tengas algo nuevo.</p>
              </div>
            } @else {
              @for (notification of notifications; track notification) {
                <div class="notification" [class.notification--unread]="!notification.isDone">
                  <div class="notification__content">
                    <div class="notification__meta">
                      @if (!notification.isDone) {
                        <span class="notification__dot" aria-hidden="true"></span>
                      }
                      <span class="notification__date">{{ notification.dateAdded | date: 'medium' }}</span>
                    </div>

                    <p class="notification__message">{{ notification.message }}</p>

                    @if ((notification.entityType === 'Report' && notification.entityId) || !notification.isDone) {
                      <div class="notification__actions">
                        @if (notification.entityType === 'Report' && notification.entityId) {
                          <button
                            matRipple
                            [disabled]="downloadingNotificationId === notification.notificationId"
                            (click)="downloadReportNotification(notification)"
                            class="btn-download"
                          >
                            <span>Descargar</span>
                            <mat-icon [class.spin]="downloadingNotificationId === notification.notificationId">
                              {{ downloadingNotificationId === notification.notificationId ? 'autorenew' : 'download' }}
                            </mat-icon>
                          </button>
                        }

                        @if (!notification.isDone) {
                          <button
                            matRipple
                            (click)="onDoneNotification(notification.notificationId)"
                            class="btn-acknowledged"
                          >
                            <span>Marcar como leído</span>
                            <mat-icon>done_all</mat-icon>
                          </button>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
            }
          </div>
        </div>
      </p-popover>
    }

    <button matRipple class="account-toggle" (click)="accountShares.toggle($event)">
      <div class="account-toggle__avatar">
        <span class="account-toggle__initials">
          {{ getInitials(getAccountName()) }}
        </span>

        @if (userInfo.user.isImpersonated) {
          <div class="account-toggle__avatar main-account">
            <span class="account-toggle__initials">
              {{ getInitials(getImpersonateName()) }}
            </span>
          </div>
        }
      </div>
      <div class="account-toggle__icon" [class.account-toggle__icon--rotate]="accountShares.render">
        <mat-icon>arrow_drop_down</mat-icon>
      </div>
    </button>

    <p-popover styleClass="account-menu" #accountShares>
      <header class="account-menu__header">
        <div class="account-menu__avatar" [class.account-menu__avatar--impersonate]="userInfo.user.isImpersonated">
          <span class="account-menu__initials">
            {{ getInitials(userInfo.user.isImpersonated ? getImpersonateName() : getAccountName()) }}
          </span>
        </div>
        <div class="account-menu__userInfo">
          <span class="account-menu__username">
            {{ userInfo.user.isImpersonated ? getImpersonateName() : getAccountName() }}
          </span>
          <div class="account-menu__badge">
            <span>{{ userInfo.user.isImpersonated ? 'Usuario' : 'Administrador' }}</span>
          </div>
        </div>
      </header>

      <div class="account-menu__divider"></div>

      <!-- <button class="account-menu__item" (click)="navigateAccount()" disabled>
        <div class="account-menu__content">
          <i class="pi pi-user account-menu__icon"></i>
          <span class="account-menu__label">Cuenta</span>
        </div>

        <div></div>
      </button> -->

      <!-- INICIO -->
      @if (hasPermission('users:impersonate', 'innovaPlatform')) {
        <button class="account-menu__item" (click)="imp.toggle($event)" (keydown.enter)="imp.toggle($event)">
          <div class="account-menu__content">
            <i class="pi pi-face-smile account-menu__icon"></i>
            <span class="account-menu__label">Personificar</span>
          </div>

          <div>
            @if (imp.render) {
              <i class="pi pi-angle-up account-menu__icon"></i>
            } @else {
              <i class="pi pi-angle-down account-menu__icon"></i>
            }
          </div>
        </button>

        <p-popover styleClass="custom-overlay" #imp>
          <div class="overlay-searchbox">
            <div class="searchbox-field">
              <label for="companyUserSearch">
                <mat-icon>search</mat-icon>
              </label>

              <input
                matInput
                id="companyUserSearch"
                name="companyUserSearch"
                [(ngModel)]="companyUserSearch"
                (input)="onInputCompanyUserSearch($event)"
                placeholder="Buscar usuario o empresa"
              />

              @if (companyUserSearch) {
                <button (click)="companyUserSearch = ''; onInputCompanyUserSearch('')">
                  <mat-icon>close</mat-icon>
                </button>
              }
            </div>
          </div>
          <div class="company-list">
            @for (company of filteredCompanies; track company.id) {
              <div class="company-item">
                <button
                  class="company-header"
                  (click)="toggleCompany(company.id)"
                  (keydown.enter)="toggleCompany(company.id)"
                  tabindex="0"
                  role="button"
                >
                  <span class="company-header__name">{{ company.name }}</span>
                  <mat-icon>
                    {{ expandedCompanyId === company.id ? 'expand_less' : 'expand_more' }}
                  </mat-icon>
                </button>

                @if (expandedCompanyId === company.id) {
                  <div class="list-item__unit-sublist">
                    @for (user of company.users; track user.id) {
                      <button class="list-item__toggle-btn" style="gap: 8px" (click)="onUserClick(user)">
                        <div class="list-item__icon list-item__icon--box">
                          <mat-icon>person</mat-icon>
                        </div>
                        <div class="list-item__info">
                          <span class="list-item__label">{{ user.fullName }}</span>
                          <span class="list-item__label list-item__label--secondary">({{ user.username }})</span>
                        </div>

                        <span
                          class="user-type-badge"
                          [class.user-type-badge--admin]="isAdministrator(user)"
                          [attr.aria-label]="'Tipo de usuario: ' + getUserTypeLabel(user)"
                        >
                          <mat-icon class="user-type-badge__icon">
                            {{ isAdministrator(user) ? 'shield_person' : 'person' }}
                          </mat-icon>
                          <span>{{ getUserTypeLabel(user) }}</span>
                        </span>
                      </button>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </p-popover>
      }

      <!-- FIN -->

      <div class="account-menu__divider"></div>

      @if (userInfo.user.isImpersonated) {
        <button class="account-menu__item" (click)="resetImpersonation()">
          <div class="account-menu__content">
            <i class="pi pi-arrow-right-arrow-left account-menu__icon"></i>
            <span class="account-menu__label">Volver a tu Cuenta</span>
          </div>

          <div></div>
        </button>
      }

      <button class="account-menu__item account-menu__item--logout" (click)="logout()">
        <div class="account-menu__content" style="color: #ff4141">
          <i class="pi pi-sign-out account-menu__icon"></i>
          <span class="account-menu__label">Cerrar Sesión</span>
        </div>

        <div></div>
      </button>
    </p-popover>

    <div class="time-date-container">
      <span class="time">{{ currentTime }}</span>
      <span class="date">{{ currentDate }}</span>
    </div>
  </div>
</header>
